module.exports = __webpack_public_path__ + "959cc0fd8b4a267654d94f7a7eb95555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/thesafezone_white.png
// module id = 323
// module chunks = 1